import { render, staticRenderFns } from "./SuspensionFunction.vue?vue&type=template&id=af52c1b4&scoped=true"
import script from "./SuspensionFunction.vue?vue&type=script&lang=js"
export * from "./SuspensionFunction.vue?vue&type=script&lang=js"
import style0 from "./SuspensionFunction.vue?vue&type=style&index=0&id=af52c1b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af52c1b4",
  null
  
)

export default component.exports